export { SearchFooter } from './SearchFooter';
